// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-new-customer-user-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
}
.tenant-administrator-new-customer-user-container{
    width: 32vw;
    opacity: 0;
    border-radius: 5px;
    margin-bottom: 2vh;
    background-color: white;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    transform: translateX(-100%);
    animation: tenant-administrator-new-customer-user-container-fade-in 1s ease-out forwards;
}
@keyframes tenant-administrator-new-customer-user-container-fade-in {
    from{
        opacity: 0;
        transform: translateX(-100%);
    }
    80%{
        opacity: 1;
        transform: translateX(5%);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
.tenant-administrator-new-customer-user-header{
    color: white;
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: 5px  5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
}
.tenant-administrator-new-customer-user-header h1{
    margin: 0px;
    font-size: 22px;
    font-weight: 600;
}
.tenant-administrator-new-customer-user-header p{
    margin: 0px;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.tenant-administrator-new-customer-user-body{
    max-height: 65vh;
    overflow: auto;
    box-sizing: border-box;
    padding: 0px 25px;
}
.tenant-administrator-new-customer-user-body::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-new-customer-user-body::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgb(155, 155, 155);
}
.tenant-administrator-new-customer-user-entry-container{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
    background-color: rgba(222, 229, 233,0.6);
}
.tenant-administrator-new-customer-user-entry-container:focus-within{
    border-bottom: 2px solid rgb(119, 12, 12);
    background-color: rgb(221, 232, 238);
}
.tenant-administrator-new-customer-user-entry-container p{
    margin: 0px;
    font-size: 12px;
    cursor: default;
}
.tenant-administrator-new-customer-user-entry-container span{
    color: red;
}
.tenant-administrator-new-customer-user-entry-container input{
    width: 100%;
    outline: none;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
}
.tenant-administrator-new-customer-user-entry-container select{
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
}


.tenant-administrator-new-customer-user-selected-country-display{
    display: flex;
    justify-content: space-between;
}
.tenant-administrator-new-customer-user-selected-country-display p{
    font-size: 14px;
    margin: 2px 0px;
}
.tenant-administrator-new-customer-user-selected-country-display .cancel-p{
    cursor: pointer;
    color: rgb(54, 54, 54);
}
.tenant-administrator-new-customer-user-countries-browser{
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    right: 0;
    z-index: 1;
    display: none;
    overflow: auto;
    max-height: 17vh;
    background-color: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}
.tenant-administrator-new-customer-user-countries-browser.active{
    display: block;
}
.tenant-administrator-new-customer-user-countries-browser::-webkit-scrollbar{
    width: 4px;
}
.tenant-administrator-new-customer-user-countries-browser::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: gray;
}
.tenant-administrator-new-customer-user-countries-browser div{
    padding: 5px 16px;
    font-size: 14px;
    cursor: pointer;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    border: 1px solid rgb(250, 250, 250);
}
.tenant-administrator-new-customer-user-countries-browser div:hover{
    background-color: rgb(221, 232, 238);
}


.tenant-administrator-new-customer-user-buttons-container{
    margin: 16px 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 4px;
}
.tenant-administrator-new-customer-user-buttons-container button{
    border: none;
    cursor: pointer;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
}
.tenant-administrator-new-customer-user-buttons-container button.cancel{
    font-weight: 500;
    color: rgba(155, 30, 30, 0.952);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-new-customer-user-buttons-container button.add.active{
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in-out;
}
.tenant-administrator-new-customer-user-buttons-container button.add.active:hover{
    opacity: 0.9;
}
.tenant-administrator-new-customer-user-buttons-container button.add.inactive{
    cursor: not-allowed;
    color: rgb(190, 190, 190);
}

.tenant-administrator-new-customer-user-creating-container,
.tenant-administrator-new-customer-user-registering-container{
    padding: 16px 20px;
    padding-top: 22px;
    text-align: center;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-new-customer-user-creating-container div,
.tenant-administrator-new-customer-user-registering-container div{
    width: 32px;
    height: 32px;
    display: inline-block;
    border-radius: 50%;
    border: 2px solid rgba(155, 30, 30, 0.952);
    border-top-color: transparent;
}
.tenant-administrator-new-customer-user-creating-container div{
    animation: tenant-administrator-new-customer-user-creating-spinner 0.8s linear infinite;
}
.tenant-administrator-new-customer-user-registering-container div{
    animation: tenant-administrator-new-customer-user-registering-spinner 0.8s linear infinite;
}
@keyframes tenant-administrator-new-customer-user-creating-spinner{
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
@keyframes tenant-administrator-new-customer-user-registering-spinner{
    from{
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
}
.tenant-administrator-new-customer-user-creating-container p,
.tenant-administrator-new-customer-user-registering-container p{
    margin: 10px 0px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.tenant-administrator-new-customer-user-created-registered-container{
    position: relative;
    padding: 16px 20px;
    text-align: center;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-new-customer-user-created-registered-container .details-container p{
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-new-customer-user-created-registered-container .details-container div{
    text-align: right;
}
.tenant-administrator-new-customer-user-created-registered-container .details-container div button{
    padding: 8px 20px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    color: white;
    background-color: green;
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-new-customer-user-created-registered-container .details-container div button:hover{
    background-color: rgb(0, 146, 0);
}
.tenant-administrator-new-customer-user-created-registered-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
    font-family: lato, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
}
.tenant-administrator-new-customer-user-created-registered-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-new-customer-user-created-registered-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-new-customer-user-created-registered-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}


.tenant-administrator-new-customer-user-create-conflict-container{
    position: relative;
    padding: 16px 20px;
    text-align: center;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-new-customer-user-create-conflict-container .details-container{
    text-align: left;
}
.tenant-administrator-new-customer-user-create-conflict-container .details-container p{
    margin: 5px 0px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-new-customer-user-create-conflict-container .details-container div{
    text-align: right;
    padding-top: 10px;
}
.tenant-administrator-new-customer-user-create-conflict-container .details-container div button{
    padding: 8px 20px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-new-customer-user-create-conflict-container .details-container div button:hover{
    background-color: rgba(180, 26, 26, 0.952);
}
.tenant-administrator-new-customer-user-create-conflict-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
    font-family: lato, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
}
.tenant-administrator-new-customer-user-create-conflict-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-new-customer-user-create-conflict-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-new-customer-user-create-conflict-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}

.tenant-administrator-new-customer-user-create-error-container{
    position: relative;
    padding: 16px 20px;
    text-align: center;
    border-radius: 4px;
    background-color: white;
}
.tenant-administrator-new-customer-user-create-error-container .details-container{
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tenant-administrator-new-customer-user-create-error-container .details-container div{
    text-align: right;
}
.tenant-administrator-new-customer-user-create-error-container .details-container div button{
    padding: 8px 20px;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.tenant-administrator-new-customer-user-create-error-container .details-container div button:hover{
    background-color: rgba(180, 26, 26, 0.952);
}
.tenant-administrator-new-customer-user-create-error-escape-button-container{
    position: absolute;
    top: 0px;
    right: -60px;
    cursor: pointer;
    font-family: lato, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
}
.tenant-administrator-new-customer-user-create-error-escape-button-container:hover button{
    color: rgb(96, 96, 96);
}
.tenant-administrator-new-customer-user-create-error-escape-button-container button{
    border: none;
    font-size: 20px;
    padding: 10px 16px;
    border-radius: 50%;
    cursor: pointer;
    background-color: white;
    color: rgb(175, 175, 175);
    transition: color 0.25s ease;
}
.tenant-administrator-new-customer-user-create-error-escape-button-container p{
    margin: 5px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    cursor: pointer;
    color: rgb(240, 240, 240);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/NewCustomerUser.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,4DAA4D;IAC5D,4BAA4B;IAC5B,wFAAwF;AAC5F;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,yBAAyB;IAC7B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,+BAA+B;IAC/B,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;AAC7C;AACA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6BAA6B;AACjC;;;AAGA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,4DAA4D;IAC5D,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;;;AAGA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,4DAA4D;AAChE;AACA;IACI,YAAY;IACZ,0CAA0C;IAC1C,8CAA8C;AAClD;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;IACI,uFAAuF;AAC3F;AACA;IACI,0FAA0F;AAC9F;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;;IAEI,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,4DAA4D;AAChE;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,yEAAyE;AAC7E;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,4DAA4D;AAChE;AACA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,yEAAyE;AAC7E;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,4DAA4D;AAChE;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,yEAAyE;AAC7E;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B","sourcesContent":[".tenant-administrator-new-customer-user-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 100;\r\n    height: 100vh;\r\n    width: 100vw;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n}\r\n.tenant-administrator-new-customer-user-container{\r\n    width: 32vw;\r\n    opacity: 0;\r\n    border-radius: 5px;\r\n    margin-bottom: 2vh;\r\n    background-color: white;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    transform: translateX(-100%);\r\n    animation: tenant-administrator-new-customer-user-container-fade-in 1s ease-out forwards;\r\n}\r\n@keyframes tenant-administrator-new-customer-user-container-fade-in {\r\n    from{\r\n        opacity: 0;\r\n        transform: translateX(-100%);\r\n    }\r\n    80%{\r\n        opacity: 1;\r\n        transform: translateX(5%);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateX(0);\r\n    }\r\n}\r\n.tenant-administrator-new-customer-user-header{\r\n    color: white;\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n    border-radius: 5px  5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n}\r\n.tenant-administrator-new-customer-user-header h1{\r\n    margin: 0px;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.tenant-administrator-new-customer-user-header p{\r\n    margin: 0px;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.tenant-administrator-new-customer-user-body{\r\n    max-height: 65vh;\r\n    overflow: auto;\r\n    box-sizing: border-box;\r\n    padding: 0px 25px;\r\n}\r\n.tenant-administrator-new-customer-user-body::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.tenant-administrator-new-customer-user-body::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: rgb(155, 155, 155);\r\n}\r\n.tenant-administrator-new-customer-user-entry-container{\r\n    position: relative;\r\n    margin: 20px 0px;\r\n    padding: 4px 10px;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid gray;\r\n    border-radius: 2px 2px 0px 0px;\r\n    background-color: rgba(222, 229, 233,0.6);\r\n}\r\n.tenant-administrator-new-customer-user-entry-container:focus-within{\r\n    border-bottom: 2px solid rgb(119, 12, 12);\r\n    background-color: rgb(221, 232, 238);\r\n}\r\n.tenant-administrator-new-customer-user-entry-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    cursor: default;\r\n}\r\n.tenant-administrator-new-customer-user-entry-container span{\r\n    color: red;\r\n}\r\n.tenant-administrator-new-customer-user-entry-container input{\r\n    width: 100%;\r\n    outline: none;\r\n    border: none;\r\n    box-sizing: border-box;\r\n    background-color: transparent;\r\n}\r\n.tenant-administrator-new-customer-user-entry-container select{\r\n    width: 100%;\r\n    border: none;\r\n    outline: none;\r\n    background-color: transparent;\r\n}\r\n\r\n\r\n.tenant-administrator-new-customer-user-selected-country-display{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.tenant-administrator-new-customer-user-selected-country-display p{\r\n    font-size: 14px;\r\n    margin: 2px 0px;\r\n}\r\n.tenant-administrator-new-customer-user-selected-country-display .cancel-p{\r\n    cursor: pointer;\r\n    color: rgb(54, 54, 54);\r\n}\r\n.tenant-administrator-new-customer-user-countries-browser{\r\n    position: absolute;\r\n    top: calc(100% + 2px);\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 1;\r\n    display: none;\r\n    overflow: auto;\r\n    max-height: 17vh;\r\n    background-color: white;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n.tenant-administrator-new-customer-user-countries-browser.active{\r\n    display: block;\r\n}\r\n.tenant-administrator-new-customer-user-countries-browser::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.tenant-administrator-new-customer-user-countries-browser::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: gray;\r\n}\r\n.tenant-administrator-new-customer-user-countries-browser div{\r\n    padding: 5px 16px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    border: 1px solid rgb(250, 250, 250);\r\n}\r\n.tenant-administrator-new-customer-user-countries-browser div:hover{\r\n    background-color: rgb(221, 232, 238);\r\n}\r\n\r\n\r\n.tenant-administrator-new-customer-user-buttons-container{\r\n    margin: 16px 25px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    box-sizing: border-box;\r\n    padding-right: 4px;\r\n}\r\n.tenant-administrator-new-customer-user-buttons-container button{\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 8px 20px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n}\r\n.tenant-administrator-new-customer-user-buttons-container button.cancel{\r\n    font-weight: 500;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-buttons-container button.add.active{\r\n    color: white;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: background-color 0.25s ease-in-out;\r\n}\r\n.tenant-administrator-new-customer-user-buttons-container button.add.active:hover{\r\n    opacity: 0.9;\r\n}\r\n.tenant-administrator-new-customer-user-buttons-container button.add.inactive{\r\n    cursor: not-allowed;\r\n    color: rgb(190, 190, 190);\r\n}\r\n\r\n.tenant-administrator-new-customer-user-creating-container,\r\n.tenant-administrator-new-customer-user-registering-container{\r\n    padding: 16px 20px;\r\n    padding-top: 22px;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-new-customer-user-creating-container div,\r\n.tenant-administrator-new-customer-user-registering-container div{\r\n    width: 32px;\r\n    height: 32px;\r\n    display: inline-block;\r\n    border-radius: 50%;\r\n    border: 2px solid rgba(155, 30, 30, 0.952);\r\n    border-top-color: transparent;\r\n}\r\n.tenant-administrator-new-customer-user-creating-container div{\r\n    animation: tenant-administrator-new-customer-user-creating-spinner 0.8s linear infinite;\r\n}\r\n.tenant-administrator-new-customer-user-registering-container div{\r\n    animation: tenant-administrator-new-customer-user-registering-spinner 0.8s linear infinite;\r\n}\r\n@keyframes tenant-administrator-new-customer-user-creating-spinner{\r\n    from{\r\n        transform: rotate(0deg);\r\n    }\r\n    to{\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n@keyframes tenant-administrator-new-customer-user-registering-spinner{\r\n    from{\r\n        transform: rotate(0deg);\r\n    }\r\n    to{\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n.tenant-administrator-new-customer-user-creating-container p,\r\n.tenant-administrator-new-customer-user-registering-container p{\r\n    margin: 10px 0px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.tenant-administrator-new-customer-user-created-registered-container{\r\n    position: relative;\r\n    padding: 16px 20px;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-container .details-container p{\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-container .details-container div{\r\n    text-align: right;\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-container .details-container div button{\r\n    padding: 8px 20px;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    color: white;\r\n    background-color: green;\r\n    transition: background-color 0.25s ease-in;\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-container .details-container div button:hover{\r\n    background-color: rgb(0, 146, 0);\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-escape-button-container{\r\n    position: absolute;\r\n    top: 0px;\r\n    right: -60px;\r\n    cursor: pointer;\r\n    font-family: lato, \"Helvetica Neue\", Helvetica, Roboto, Arial, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-escape-button-container:hover button{\r\n    color: rgb(96, 96, 96);\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-escape-button-container button{\r\n    border: none;\r\n    font-size: 20px;\r\n    padding: 10px 16px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    background-color: white;\r\n    color: rgb(175, 175, 175);\r\n    transition: color 0.25s ease;\r\n}\r\n.tenant-administrator-new-customer-user-created-registered-escape-button-container p{\r\n    margin: 5px 0px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-weight: 900;\r\n    cursor: pointer;\r\n    color: rgb(240, 240, 240);\r\n}\r\n\r\n\r\n.tenant-administrator-new-customer-user-create-conflict-container{\r\n    position: relative;\r\n    padding: 16px 20px;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-container .details-container{\r\n    text-align: left;\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-container .details-container p{\r\n    margin: 5px 0px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-container .details-container div{\r\n    text-align: right;\r\n    padding-top: 10px;\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-container .details-container div button{\r\n    padding: 8px 20px;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    color: white;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: background-color 0.25s ease-in;\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-container .details-container div button:hover{\r\n    background-color: rgba(180, 26, 26, 0.952);\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-escape-button-container{\r\n    position: absolute;\r\n    top: 0px;\r\n    right: -60px;\r\n    cursor: pointer;\r\n    font-family: lato, \"Helvetica Neue\", Helvetica, Roboto, Arial, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-escape-button-container:hover button{\r\n    color: rgb(96, 96, 96);\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-escape-button-container button{\r\n    border: none;\r\n    font-size: 20px;\r\n    padding: 10px 16px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    background-color: white;\r\n    color: rgb(175, 175, 175);\r\n    transition: color 0.25s ease;\r\n}\r\n.tenant-administrator-new-customer-user-create-conflict-escape-button-container p{\r\n    margin: 5px 0px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-weight: 900;\r\n    cursor: pointer;\r\n    color: rgb(240, 240, 240);\r\n}\r\n\r\n.tenant-administrator-new-customer-user-create-error-container{\r\n    position: relative;\r\n    padding: 16px 20px;\r\n    text-align: center;\r\n    border-radius: 4px;\r\n    background-color: white;\r\n}\r\n.tenant-administrator-new-customer-user-create-error-container .details-container{\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-create-error-container .details-container div{\r\n    text-align: right;\r\n}\r\n.tenant-administrator-new-customer-user-create-error-container .details-container div button{\r\n    padding: 8px 20px;\r\n    border: none;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    color: white;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: background-color 0.25s ease-in;\r\n}\r\n.tenant-administrator-new-customer-user-create-error-container .details-container div button:hover{\r\n    background-color: rgba(180, 26, 26, 0.952);\r\n}\r\n.tenant-administrator-new-customer-user-create-error-escape-button-container{\r\n    position: absolute;\r\n    top: 0px;\r\n    right: -60px;\r\n    cursor: pointer;\r\n    font-family: lato, \"Helvetica Neue\", Helvetica, Roboto, Arial, sans-serif;\r\n}\r\n.tenant-administrator-new-customer-user-create-error-escape-button-container:hover button{\r\n    color: rgb(96, 96, 96);\r\n}\r\n.tenant-administrator-new-customer-user-create-error-escape-button-container button{\r\n    border: none;\r\n    font-size: 20px;\r\n    padding: 10px 16px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    background-color: white;\r\n    color: rgb(175, 175, 175);\r\n    transition: color 0.25s ease;\r\n}\r\n.tenant-administrator-new-customer-user-create-error-escape-button-container p{\r\n    margin: 5px 0px;\r\n    text-align: center;\r\n    font-size: 14px;\r\n    font-weight: 900;\r\n    cursor: pointer;\r\n    color: rgb(240, 240, 240);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
